import { Pipe, PipeTransform, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { SubscriptionSuspendReason } from '../enums/subscription-suspend-reason';
import { SubscriptionSuspendReasonProviderService } from '../providers/subscription-suspend-reason-provider.service';

@Pipe({
  name: 'subscriptionSuspendReason',
})
export class SubscriptionSuspendReasonPipe implements PipeTransform {
  private readonly provider = inject(SubscriptionSuspendReasonProviderService);

  public transform(reason: SubscriptionSuspendReason): Observable<string> {
    return this.provider.labelFor(reason);
  }
}
